import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '~/ui/form'
import { Control, FieldPath, FieldValues } from 'react-hook-form'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '~/ui/select'
import { cn } from '~/lib/utils'

type SelectEntry = {
  label: string
  value: string
}

export const SelectField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  name,
  description,
  label,
  labelClassName,
  containerClassName,
  selectEntries,
  loading,
  placeholder,
  required,
}: {
  label: string
  labelClassName?: string
  containerClassName?: string
  description?: string
  control?: Control<TFieldValues> | undefined
  name: TName
  selectEntries: SelectEntry[]
  loading?: boolean
  placeholder?: string
  required?: boolean
}) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className={containerClassName}>
          <FormLabel
            className={cn(
              'mb-1 text-sm font-normal text-gray-400',
              fieldState.error && 'text-destructive',
              labelClassName
            )}
          >
            {label}
            {required && <span className="text-destructive">*</span>}
          </FormLabel>

          <Select onValueChange={field.onChange} value={field.value || ''} disabled={loading}>
            <FormControl className="h-10 w-full p-3">
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {selectEntries.map((entry, index) => (
                <SelectItem value={entry.value} key={index}>
                  {entry.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
